import styled from 'styled-components';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Stack, Text, ButtonReset } from '@koob/margaret';
import { useSnack } from 'hooks';
import { FormField } from 'ui/forms';
import CancelConditionItemField from './CancelConditionItemField';
import { getDefaultCondition } from './utils';

const AddCondition = styled(ButtonReset).attrs({ type: 'button' })`
  max-width: max-content;
  padding: ${({ theme }) => theme.spacing(0.5)}
    ${({ theme }) => theme.spacing(0.75)};
  background-color: ${({ theme }) => theme.orangeLight};
  color: ${({ theme }) => theme.primary};
  border-radius: 4px;
  border: solid 1px transparent;
  margin-bottom: 10px;
  &:hover {
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 1px 2px 0 ${({ theme }) => theme.primaryBackground};
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
      background-color: ${theme.disabled};
      border: solid 1px ${theme.disabled};
      box-shadow: revert;
      color: ${theme.textLight};
  `}
`;

const Line = styled.div`
  border: 1px solid grey;
  height: 1px;
  opacity: 0.3;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const CancelConditionField = ({
  name,
  timezone,
  showNumberOfNights,
  setDisabledSaveButton = () => {},
  showLine = true,
  currency,
  disabled = false,
}) => {
  const { t } = useTranslation('cancellationPolicies');
  const { notify } = useSnack();
  const [{ value: cancelConditions }, , { setValue }] = useField({ name });

  const handleDeleteCondition = (conditionIndex) => {
    const copyCondition = [...cancelConditions];
    copyCondition.splice(conditionIndex, 1);
    setValue([...copyCondition]);
  };

  const handleDuplicateCondition = (conditionIndex) => {
    const copyCondition = [...cancelConditions];
    const { id, period, ...duplicatedCondition } =
      copyCondition[conditionIndex];
    duplicatedCondition.period = period?.map((date) => date?.clone?.() ?? date);
    copyCondition.splice(conditionIndex + 1, 0, duplicatedCondition);
    setValue(copyCondition);
    notify(t('duplicateConditionSuccess'));
  };

  return (
    <FormField gutterSize={1.25}>
      {cancelConditions?.map((_, index) => {
        return (
          <CancelConditionItemField
            key={index}
            index={index}
            name={name}
            timezone={timezone}
            showNumberOfNights={showNumberOfNights}
            currency={currency}
            onDelete={handleDeleteCondition}
            onDuplicate={handleDuplicateCondition}
            disabled={disabled}
          />
        );
      })}

      {!disabled && (
        <AddCondition
          onClick={() => {
            setValue([...cancelConditions, getDefaultCondition(timezone)]);
            setDisabledSaveButton(true);
          }}
        >
          <Stack alignY="center" gutterSize={0.25}>
            <i className="fa-jelly fa-regular fa-circle-plus text-lg" />
            <Text type="bodySmall">{t('addcondition')}</Text>
          </Stack>
        </AddCondition>
      )}
      {showLine && <Line className="w-full" />}
    </FormField>
  );
};

export default CancelConditionField;
